import { render, staticRenderFns } from "./EditaEvaluacionDesempeñoAcademicoDialogContent.vue?vue&type=template&id=4da24576&scoped=true"
import script from "./EditaEvaluacionDesempeñoAcademicoDialogContent.vue?vue&type=script&lang=js"
export * from "./EditaEvaluacionDesempeñoAcademicoDialogContent.vue?vue&type=script&lang=js"
import style0 from "./EditaEvaluacionDesempeñoAcademicoDialogContent.vue?vue&type=style&index=0&id=4da24576&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da24576",
  null
  
)

export default component.exports